import {BaseSettings} from '../BaseFinancialInstruments/settings/BaseSettings';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import {Spin} from 'antd';
import {useState} from 'react';
import {ConfirmModal} from 'pages/adminOpportunities/stocksListings/ViewOrders/HandleOrders';
import {
  currentInstrumentKey,
  financialInstrumentConfig,
} from '../modules/financialInstrumentConfig';

export const BondsInstrumentSettings = () => {
  const location = useLocation();
  const {
    mutation,
    handleUpdate,
    title,
    handleDispatch,
    route,
    overviewSelector,
    QUERY,
  } = financialInstrumentConfig[currentInstrumentKey(location.pathname)];

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updatedValues, setUpdatedValues] = useState({});
  const navigate = useNavigate();
  const {assetId, lang, id} = useParams();
  const dispatch = useDispatch();
  const storedData = useSelector(overviewSelector);

  const [updateBond, {loading: loadingUpdate}] = useMutation(mutation);
  const {
    data: updateData,
    refetch,
    loading,
  } = useQuery(QUERY, {
    variables: {
      getFinancialInstrumentId: id,
      language: lang,
    },
    skip: !id,
  });

  const handleSubmit = values => {
    if (id) {
      const {startDate, forDabaPro, endDate, ...restValues} = values;
      setUpdatedValues({
        startDate,
        endDate,
        forDabaPro,
        settings: {
          ...restValues,
        },
      });
      setOpenUpdateModal(true);
    } else {
      dispatch(handleDispatch({...values}));
      navigate(route({param: assetId, name: 'trading'}));
    }
  };

  if (loading) {
    return (
      <div className="query-loading">
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div>
      <BaseSettings
        handleSave={handleSubmit}
        existingValues={
          id ? updateData?.getFinancialInstrument?.data || {} : storedData
        }
      />
      <ConfirmModal
        openModal={openUpdateModal}
        setOpenModal={() => setOpenUpdateModal(false)}
        loading={loadingUpdate}
        title={`Update ${title}`}
        confirmText={`Are you sure you want update to this ${title}?`}
        handleOperation={() =>
          handleUpdate(
            updateBond,
            id,
            lang,
            updatedValues,
            refetch,
            setOpenUpdateModal,
          )
        }
      />
    </div>
  );
};
